import React, { useState } from "react";
import Sidebar from "../../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import { TbStars } from "react-icons/tb";
import { PiTextColumnsLight } from "react-icons/pi";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { addProgram } from "../../redux/actions/programActions";
import PageComponent from "../../Components/PageComponent";

function AddProgram() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // Heading styles
      [{ font: [] }], // Font selection
      [{ list: "bullet" }], // Ordered (numbered) and unordered (bullet) lists
      ["bold", "italic", "underline"], // Font styles
      [{ align: [] }], // Alignment options
      ["clean"], // Clear formatting
    ],
  };

  const formats = [
    "font",
    "header",
    "list", // Include list format
    "bold",
    "italic",
    "underline",
    "align",
  ];

  // Initialize form state
  const [formData, setFormData] = useState({
    program_name: "",
    description: "",
    eligibility_criteria: "",
    program_benefits: "",
    files: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, files: file }));
  };

   // Strip HTML to validate rich text fields
   const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleSave = (e) => {
    e.preventDefault();

    const plainDescription = stripHtml(formData.description);
    const plainEligibilityCriteria = stripHtml(formData.eligibility_criteria);
    const plainProgramBenefits = stripHtml(formData.program_benefits);


    if (!formData.program_name ) {
      alert("Program name is required.");
      return;
    }

    if (!plainDescription.trim()) {
      alert("Description is required.");
      return;
    }
    if (!plainEligibilityCriteria.trim()) {
      alert("Eligibility criteria is required.");
      return;
    }
    if (!plainProgramBenefits.trim()) {
      alert("Program Benefits are required.");
      return;
    }
    

    const programInfo = new FormData();
    programInfo.append("program_name", formData.program_name);
    programInfo.append("description", formData.description);
    programInfo.append("eligibity_criteria", formData.eligibility_criteria);
    programInfo.append("program_benefits", formData.program_benefits);
    if (formData.files) programInfo.append("files", formData.files);

    dispatch(addProgram(programInfo)); // Add new program
    alert("Program added successfully");

    // Reset form data after submission
    setFormData({
      program_name: "",
      description: "",
      eligibility_criteria: "",
      program_benefits: "",
      files: null,
    });


    window.location.reload(true);
    // navigate("/academics&international/international/allPrograms")
  };

  return (
    <> 
        <PageComponent>
   
    <div className="flex w-screen h-screen bg-[#F8F7FA] overflow-hidden">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      <div className="flex-1 min-h-screen p-6 ml-64 overflow-auto">
        {/* Page Title */}
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Academics & International</span>
          <span>/</span>
          <span className="text-black">International Section</span>
        </div>

        {/* Buttons */}
        <div className="flex items-center mt-4 space-x-4">
          <button
            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
            onClick={() =>
              navigate("/academics&international/international/addProgram")
            }
          >
            <TbStars className="mr-2" />
            Add Program
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() =>
              navigate("/academics&international/international/allPrograms")
            }
          >
            <PiTextColumnsLight className="mr-2" />
            All Programs
          </button>
        </div>

        {/* Add Degree Form */}
        <div className="w-full p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="mb-4 text-xl font-semibold text-gray-700">Add New Program</h2>
          <form onSubmit={handleSave}>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="programName">
                  Programme Name
                </label>
                <input
                  id="programName"
                  name="program_name"
                  type="text"
                  value={formData.program_name}
                  onChange={handleInputChange}
                  className="w-1/2 px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>
            </div>

            {/* Description */}
            <div className="mt-6">
              <label className="block mb-1 text-gray-700">Description</label>
              <ReactQuill
                id="description"
                value={formData.description}
                onChange={(value) => setFormData({ ...formData, description: value })}
                theme="snow"
                modules={modules}
                formats={formats}
                className="h-[150px] mb-1"
              />
            </div>

            {/* Eligibility Criteria */}
            <div>
              <label className="block mt-12 mb-1 text-gray-700">Eligibility Criteria</label>
              <ReactQuill
                id="eligibility_criteria"
                value={formData.eligibility_criteria}
                onChange={(value) => setFormData({ ...formData, eligibility_criteria: value })}
                theme="snow"
                modules={modules}
                formats={formats}
                className="h-[150px]"
              />
            </div>

            {/* Programme Benefits */}
            <div>
              <label className="block mt-12 mb-1 text-gray-700">Programme Benefits</label>
              <ReactQuill
                id="program_benefits"
                value={formData.program_benefits}
                onChange={(value) => setFormData({ ...formData, program_benefits: value })}
                theme="snow"
                modules={modules}
                formats={formats}
                className="h-[150px]"
              />
            </div>

            {/* File Upload */}
            {/* <div className="col-span-4 mt-12">
              <label className="block mb-1 text-sm font-medium text-gray-600">Upload Document</label>
              <div className="mb-4">
                <div className="flex items-center space-x-6">
                  <input
                    type="file"
                    onChange={handleFileChange}
                    className="w-3/4 px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  />
                </div>
              </div>
            </div> */}
           <div className="col-span-4 mt-12">
  <label className="block mb-1 text-sm font-medium text-gray-600">Upload Document</label>
  
  <div className="mb-4">
    <div className="flex items-center space-x-6">
      {/* Text input to show selected file name */}
      <input
        type="text"
        value={formData.files ? formData.files.name : ""}
        readOnly
        placeholder="No file chosen"
        className="w-3/4 px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
      />
      
      {/* Conditional rendering for Browse Doc or Remove button */}
      {!formData.files ? (
        <button
          type="button"
          onClick={() => document.getElementById("fileInput").click()} // Trigger file input click
          className="px-4 py-2 font-semibold border rounded-md text-secondary-2-color border-secondary-2-color bg-opacity-10"
        >
          Browse Doc
        </button>
      ) : (
        <button
          type="button"
          onClick={() => {
            setFormData((prev) => ({ ...prev, files: null })); // Clear selected file
          }}
          className="px-4 py-2 font-semibold text-red-500 border border-red-500 rounded-md bg-opacity-10"
        >
          Remove
        </button>
      )}
      
      {/* Hidden file input */}
      <input
        id="fileInput"
        type="file"
        onChange={handleFileChange}
        className="hidden"
      />
    </div>
  </div>
</div>



            <div className="flex justify-end mt-6 space-x-4">
              <button
                type="reset"
                className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </PageComponent> </>
  );
}

export default AddProgram;
